module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Sommario")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Titolo Pagina")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Pagina")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("Presa da Tre Guardie del Corpo (Ménage, #5)")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c004"
    }
  }, [_vm._v("Nota dell’Autrice")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c005"
    }
  }, [_vm._v("Capitolo I")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capitolo II")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capitolo III")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capitolo IV")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capitolo V")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capitolo VI")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capitolo VII")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capitolo VIII")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Altre storie di Jasmine Black in italiano:")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0